import { render, staticRenderFns } from "./indexRevenue.vue?vue&type=template&id=2300e9a2&scoped=true"
import script from "./indexRevenue.vue?vue&type=script&lang=js"
export * from "./indexRevenue.vue?vue&type=script&lang=js"
import style0 from "./indexRevenue.vue?vue&type=style&index=0&id=2300e9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300e9a2",
  null
  
)

export default component.exports